import React, { useState, useEffect } from 'react';
import { 
  UserCircle, Loader2, Save, Phone, Mail, Briefcase, BookOpen, Users
} from 'lucide-react';
import { teacherPanelAPI } from '../../services/api';

const TeacherProfile = () => {
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    phone: '',
    bio: ''
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await teacherPanelAPI.getProfile();
      const teacherData = response.data.teacher;
      setTeacher(teacherData);
      setFormData({
        phone: teacherData.user?.phone || '',
        bio: teacherData.bio || ''
      });
    } catch (error) {
      console.error('Profilni yuklashda xato:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await teacherPanelAPI.updateProfile(formData);
      await fetchProfile();
      setEditMode(false);
    } catch (error) {
      console.error('Saqlashda xato:', error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Loader2 className="spinner" size={40} />
        <p>Yuklanmoqda...</p>
      </div>
    );
  }

  const user = teacher?.user;

  return (
    <div className="page-container">
      <header className="page-header">
        <div className="page-title">
          <h1><UserCircle size={28} /> Mening profilim</h1>
          <p>Shaxsiy ma'lumotlar</p>
        </div>
        {!editMode ? (
          <button className="btn btn-primary" onClick={() => setEditMode(true)}>
            Tahrirlash
          </button>
        ) : (
          <div className="header-actions">
            <button className="btn btn-secondary" onClick={() => setEditMode(false)}>
              Bekor qilish
            </button>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
              {saving ? <Loader2 className="spinner" size={18} /> : <Save size={18} />}
              Saqlash
            </button>
          </div>
        )}
      </header>

      <div className="profile-container">
        {/* Profile Card */}
        <div className="profile-card">
          <div className="profile-avatar">
            {user?.first_name?.[0]}{user?.last_name?.[0]}
          </div>
          <h2>{user?.full_name}</h2>
          <p className="profile-role">O'qituvchi</p>
          
          <div className="profile-stats">
            <div className="profile-stat">
              <Briefcase size={20} />
              <span>{teacher?.experience_years || 0} yil tajriba</span>
            </div>
            <div className="profile-stat">
              <BookOpen size={20} />
              <span>{teacher?.subjects?.length || 0} fan</span>
            </div>
            <div className="profile-stat">
              <Users size={20} />
              <span>{teacher?.groups?.length || 0} guruh</span>
            </div>
          </div>
        </div>

        {/* Profile Details */}
        <div className="profile-details">
          <div className="card">
            <div className="card-header">
              <h3>Asosiy ma'lumotlar</h3>
            </div>
            <div className="card-body">
              <div className="detail-row">
                <label>F.I.Sh</label>
                <span>{user?.full_name}</span>
              </div>
              <div className="detail-row">
                <label>Login</label>
                <code className="login-code">{user?.username}</code>
              </div>
              <div className="detail-row">
                <label><Phone size={16} /> Telefon</label>
                {editMode ? (
                  <input 
                    type="text"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    placeholder="+998 90 123 45 67"
                  />
                ) : (
                  <span>{user?.phone || '-'}</span>
                )}
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <h3>Biografiya</h3>
            </div>
            <div className="card-body">
              {editMode ? (
                <textarea
                  value={formData.bio}
                  onChange={(e) => setFormData({...formData, bio: e.target.value})}
                  placeholder="O'zingiz haqingizda qisqacha..."
                  rows={4}
                />
              ) : (
                <p>{teacher?.bio || "Ma'lumot kiritilmagan"}</p>
              )}
            </div>
          </div>

          {/* Subjects */}
          {teacher?.subjects?.length > 0 && (
            <div className="card">
              <div className="card-header">
                <h3>Fanlar</h3>
              </div>
              <div className="card-body">
                <div className="tags">
                  {teacher.subjects.map(s => (
                    <span key={s.id} className="tag">{s.name}</span>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Groups */}
          {teacher?.groups?.length > 0 && (
            <div className="card">
              <div className="card-header">
                <h3>Guruhlar</h3>
              </div>
              <div className="card-body">
                <div className="tags">
                  {teacher.groups.map(g => (
                    <span key={g.id} className="tag">{g.display_name}</span>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeacherProfile;
